@if (type === 'linear') {

<div
  [class]="'h-[7px] w-full overflow-hidden rounded-full bg-slate200 ' + trackClasses"
  role="progressbar"
  [attr.aria-valuenow]="progress">

  <div
    [class]="
      'h-full rounded-full bg-indigo600 transition-all duration-300 ease-out ' + progressClasses
    "
    [style.width.%]="progress"
  ></div>
</div>

} @else {

<div class="relative h-[90px] w-[190px]">

  <svg
    viewBox="0 0 180 100"
    class="h-full w-full">

    <!-- Background Arc -->
    <path
      d="M20 90 A70 70 0 0 1 160 90"
      fill="none"
      stroke="#DBE4F3"
      stroke-width="12"
      stroke-linecap="round" />

    <!-- Progress Arc -->
    <path
      d="M20 90 A70 70 0 0 1 160 90"
      fill="none"
      stroke="#4F46E5"
      stroke-width="12"
      stroke-linecap="round"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="dashOffset"
      style="
        transition: stroke-dashoffset .5s ease;
        transform-origin:center;
      " />

  </svg>

  <div
    class="absolute left-1/2 top-[58px] -translate-x-1/2 text-center">

    <p class="text-3xl font-semibold leading-none text-slate900">
      {{progress}}%
    </p>

  </div>

</div>

}